import { render } from "./LicenseErrors.vue?vue&type=template&id=a2e99c68&ts=true"
import script from "./LicenseErrors.vue?vue&type=script&lang=ts"
export * from "./LicenseErrors.vue?vue&type=script&lang=ts"

import "./LicenseErrors.vue?vue&type=style&index=0&id=a2e99c68&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__